import { IBiLink } from '@suvo-bi-lib';

export const ORGANISATION_NAVIGATION_LINKS: IBiLink[] = [
  {
    route: 'my-organisations/organisations',
    displayName: 'Organisations',
    displayIcon: 'business',
  },
  {
    route: 'my-organisations/invites',
    displayName: 'Invitations',
    displayIcon: 'mail_outline'
  }
];